import React from "react";
import MultiStatusList from "./MultiStatusList";
import { MultiModalPickerProps } from "../props";
import Status from "components/Status/Status";
import MultiModalPickerWithChooseButton from "../MultiModalPickerWithChooseButton";
import { LabelList } from "../LabelList";

interface Props extends MultiModalPickerProps<server.dto.StatusSmall> {
  mainArea: server.dto.MainAreas;
}

const StatusMultiModalPicker = (props: Props) => {
  const { mainArea, ...rest } = props;

  return <>
    <MultiModalPickerWithChooseButton<server.dto.StatusSmall>
      onNewClicked={() => { }}
      renderLabelContent={(s) => <Status status={s} />}
      getId={(s) => s.statusId}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.Status.resxStatus}
      modalSize="small"
      renderModalContent={(editedValue, setEditedValue) => <MultiStatusList
        mainArea={mainArea}
        excludeKeys={editedValue.map(s => s.statusId)}
        onChange={setEditedValue}
        value={editedValue}
      />}

      {...rest}
    />
  </>;
};

export const SelectedStatuses = (props: { value: server.dto.StatusSmall[] }) => {
  return <LabelList
    value={props.value}
    renderLabelContent={(s) => <Status status={s} />}
    getId={(s) => s.statusId}
  />;
}

export default StatusMultiModalPicker;